import { ValueFormatterParams } from "ag-grid-community";
import { formatNumber } from "../../../utils/format/formatNumber";

export function priceFormatter(params: ValueFormatterParams): string {
  return formatNumber(params?.value, 6);
}
